import { AppBar, Toolbar } from 'components/common';
import logo from 'images/StrideUp_Logo_RGB_Neg.png';
import { FormattedMessage } from 'react-intl';
import { Link, useLocation, useParams, useSearchParams } from 'react-router-dom';
import { PageURL } from 'router/pageURL';
import { BtlApplication } from '../../api/btlApplicationForm/types';
import { useBtlApplicationInProgressById } from '../../queries';
import { ProfileSettings } from '../AppHeader/ProfileSettings';
import { ApplicationFormPageEnum } from '../../pages/ApplicationFormPage/types';
import { useAuth } from 'providers';

const normalizeApplicationType = (segment: string) => {
  if (segment.toLowerCase() === 'btlapplication') return 'btlApplication';
  return segment;
};

export const ApplicationFormHeader = () => {
  const { isSignedIn } = useAuth();
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const segments = location.pathname.split('/');
  const applicationType = normalizeApplicationType(segments[1]);
  const formSection = searchParams.get('section');
  const formApplicantNames = searchParams.get('applicantNames')?.split(',');
  const activeApplicant = parseInt(searchParams.get('activeApplicant') || '');
  const activeApplicantName = formApplicantNames?.[activeApplicant - 1] || '';
  const { id = '' } = useParams();
  const { data: btlApplicationData } = useBtlApplicationInProgressById(id);

  const currentFormSection = (formSection || '') as keyof typeof ApplicationFormPageEnum;
  const applicationFormType = `${applicationType}Form`;

  return (
    <ApplicationFormHeaderBody
      applicationFormType={applicationFormType}
      applicantName={activeApplicantName ? `${activeApplicantName}'s` : `Applicant ${activeApplicant}'s`}
      isProfileSettingsDisplayed={isSignedIn}
      currentFormSection={currentFormSection}
      btlApplicationData={btlApplicationData}
    />
  );
};

type ApplicationFormHeaderBodyProps = {
  applicationFormType: string;
  currentFormSection: keyof typeof ApplicationFormPageEnum;
  applicantName: string;
  btlApplicationData?: BtlApplication;
  isProfileSettingsDisplayed?: boolean;
};

const ApplicationFormHeaderBody = ({
  applicationFormType,
  currentFormSection,
  applicantName,
  btlApplicationData,
  isProfileSettingsDisplayed,
}: ApplicationFormHeaderBodyProps) => {
  return (
    <AppBar>
      <Toolbar className={'flex'}>
        <Link to={PageURL.ROOT} className={'text-white no-underline'}>
          <img src={logo} alt='Strideup logo' className={'w-16'} />
        </Link>
        <div className={'flex w-full items-center px-1 pl-6'}>
          <FormattedMessage id={`header.${applicationFormType}`} />
          {currentFormSection && (
            <>
              {' '}
              /{' '}
              <FormattedMessage
                id={`${applicationFormType}.${[currentFormSection]}.label`}
                values={{
                  name: applicantName,
                  title: btlApplicationData?.title,
                }}
              />
            </>
          )}
        </div>
        {isProfileSettingsDisplayed && <ProfileSettings />}
      </Toolbar>
    </AppBar>
  );
};
